import MobileStepper from '@mui/material/MobileStepper';
import styled from '@emotion/styled';
import { fontSize, spacing } from 'presentations/views/styles';
import { blueGrayPale, gray01 } from 'presentations/views/styles/color';

interface Props {
  steps: number;
  activeStep: number;
  isHideLabel?: boolean;
  width?: number;
}

export default function Component(props: Props) {
  return (
    <Container>
      <StyledStepper
        variant="progress"
        steps={props.steps + 1}
        position="static"
        activeStep={props.activeStep}
        backButton={null}
        nextButton={null}
        width={props.width}
      />
      {!props.isHideLabel && (
        <Label>
          {props.activeStep}/{props.steps}
        </Label>
      )}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
`;
const StyledStepper = styled(MobileStepper)<{ width?: number }>`
  background-color: transparent;
  width: ${({ width }) => `${width ?? '180'}px`};
  padding: 0;

  .MuiLinearProgress-colorPrimary {
    background-color: ${blueGrayPale};
  }
  .MuiMobileStepper-progress {
    width: 100%;
  }
`;
const Label = styled.span`
  margin-left: ${spacing(16)};
  font-size: ${fontSize(13)};
  color: ${gray01};
`;
